/**
 * Палитра лендинга: тёмный «чертёж» только в hero и footer;
 * центральные блоки — белый фон, тёмные линии и типографика.
 */
export const ink = '#031a38';
export const inkMid = '#0a3d6b';
export const sky = '#8ecfff';
export const paper = '#ffffff';
export const paperMuted = '#f4f5f7';
export const bodyMuted = '#4a5568';
export const borderInk = 'rgba(3, 26, 56, 0.22)';
export const borderInkHover = 'rgba(3, 26, 56, 0.4)';
